<template>
    <div v-if="renderData" :class="`mSlot mSlot-border-${$vuetify.theme.dark ? 'dark' : 'light'}`">
        {{ renderData.text }}
    </div>
</template>
// this.$vuetify.theme.dark
<script lang="js">
export default {
    name: 'MonsterSlotMarker',
    props: {
        markerData: {
            type: Array,
            required: true,
        },
    },
    computed: {
        renderData() {
            if (!this.markerData || !this.markerData.length > 0) return null
            const isStart = this.markerData.every( x=> x.isStart)
            const isEnd = this.markerData.every(x => x.isEnd)
            return {
                isStart: isStart,
                isEnd: isEnd,
                text: this.markerData.map(x => x.text).join(', '),
            }
        },
    },
}
</script>
<style scoped>
.mSlot {
    text-align: center;
    height: 100%;
    padding-top: 20%;
}
.mSlot-border-light {
    background-color: rgba(0, 132, 255, 0.473);
}
.mSlot-border-dark {
    background-color: rgba(0, 132, 255, 0.473);
}
</style>
